import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import 'swiper/css';
interface ImageModalProps {
  images: string[];
  alt: string;
  onClose: () => void;
}
const ImageModal: React.FC<ImageModalProps> = ({
  images,
  alt,
  onClose
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null);
  const swiperRef = useRef<any>(null);
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [onClose]);
  return <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} data-sentry-element="unknown" data-sentry-component="ImageModal" data-sentry-source-file="product-image-modal.tsx">
      <motion.div ref={modalRef} className="relative bg-neutral-600 bg-opacity-50 rounded-3xl p-4 max-w-4xl w-full mx-4 grid grid-cols-1 gap-4" initial={{
      scale: 0.8
    }} animate={{
      scale: 1
    }} exit={{
      scale: 0.8
    }} data-sentry-element="unknown" data-sentry-source-file="product-image-modal.tsx">
        <button onClick={onClose} className="absolute top-2 right-4 text-black dark:text-neutral-200 text-3xl font-bold z-10">
          &times;
        </button>

        <div className="w-full flex justify-center">
          <Swiper onSwiper={swiper => swiperRef.current = swiper} onSlideChange={swiper => setActiveIndex(swiper.activeIndex)} slidesPerView={1} className="w-full" data-sentry-element="Swiper" data-sentry-source-file="product-image-modal.tsx">
            {images.map((img, index) => <SwiperSlide key={index}>
                <div className="flex justify-center">
                  <Image src={img} alt={`${alt} ${index + 1}`} width={600} height={600} className="object-contain rounded-3xl" />
                </div>
              </SwiperSlide>)}
          </Swiper>
        </div>
        {images.length > 1 && <div className="flex justify-center space-x-4 mt-4">
            {images.map((img, index) => <div key={index} className={`cursor-pointer border rounded-3xl p-1 overflow-hidden ${activeIndex === index ? 'border-aloeGold' : 'border-neutral-400'}`} onClick={() => {
          setActiveIndex(index);
          if (swiperRef.current) {
            swiperRef.current.slideTo(index);
          }
        }}>
                <Image src={img} alt={`${alt} thumbnail ${index + 1}`} width={100} height={100} className="object-cover" />
              </div>)}
          </div>}
      </motion.div>
    </motion.div>;
};
export default ImageModal;